import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import '../../../../node_modules/react-image-gallery/styles/css/image-gallery.css'

import './Slider.css'


import FaCommentsO from 'react-icons/lib/fa/comments-o';
import slideOne from '../../../assets/images/slider-bg.jpg'
import slideTwo from '../../../assets/images/slider-bg-2.jpg'
import CalculatorBoard from "../../../components/Calculator-board/Calculator-board";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class Slider extends Component {
    constructor() {
        super()
    }
    render() {
        const images = [
            {
                original: slideOne,
                thumbnail: slideOne,
                originalAlt: 'Compulsory Insurance Center'
            },
            {
                original: slideTwo,
                thumbnail: slideTwo,
                originalAlt: 'Compulsory Insurance Center'
            }
        ]
        const { translate } = this.props

        return (
            <section className="slider">
                <div className="slider-container">
                    <ImageGallery
                        items={images}
                        showFullscreenButton={false}
                        infinite={false}
                        showPlayButton={false}
                        showNav={false}
                        showThumbnails={false}
                        showBullets={true}
                    />
                </div>
                <div className="slider-content">
                    <div className="slider-content-text">
                        <h3 className="slider-name">
                            {/* {translate('TPL')}  */}
                            <b>{translate('INSURANCE')}</b>
                        </h3>
                        {/* <h6 className="slider-description">{translate('PolicySearchPortalByIndividualPersons')}</h6> */}
                    </div>
                </div>
                <CalculatorBoard />
            </section>
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});
export default connect(mapStateToProps)(Slider);



// WEBPACK FOOTER //
// ./src/pages/MainPage/Slider/Slider.js